import { render } from "./MainHero.vue?vue&type=template&id=6388bdbd&scoped=true"
import script from "./MainHero.vue?vue&type=script&lang=js"
export * from "./MainHero.vue?vue&type=script&lang=js"

import "./MainHero.vue?vue&type=style&index=0&id=6388bdbd&lang=css"
import "./MainHero.vue?vue&type=style&index=1&id=6388bdbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6388bdbd"]])

export default __exports__